import type { ComponentPropsWithoutRef, FC } from 'react';

import classNames from 'classnames';

import styles from './RubCurrency.module.scss';

type Props = Omit<ComponentPropsWithoutRef<'span'>, 'children'>;

export const RubCurrency: FC<Props> = ({ className, ...props }) => (
	<span className={classNames(styles.root, className)} {...props}>
		₽
	</span>
);
